export function isDevelopmentMode() {
  const isDevelopmentMode = typeof window !== 'undefined' &&
      (window.location.search.includes('dev=true'));
  return isDevelopmentMode;
}
